// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

(function () {
  const reviewsSlider = document.querySelectorAll(".reviews-slider");
  let reviewsSwiper = [];

  for (let i = 0; i < reviewsSlider.length; i++) {
    reviewsSwiper[i] = new Swiper(reviewsSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 60,
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    });
  }
})();
